// Hook returns true if consent landing page should be shown
// Logic extracted here so we can reuse in page-layout component to hide feedback form icon

import { useFastshiftSelector } from "@/components/fastshift/src/state";

export const useShouldShowConsentLandingPage = (): boolean => {
    const { data: userDetails, error: userDetailsError } = useFastshiftSelector(
        (state) => state.userDetails
    );
    const isPartnerOrInternal =
        userDetails?.userType === "PARTNER" ||
        userDetails?.userType === "INTERNAL";

    const { data: userHasConsented, error: userConsentError } =
        useFastshiftSelector((state) => state.portalUserConsent);

    const portalHasCriticalError = userDetailsError || userConsentError;

    const shouldShowConsentLandingPage =
        !isPartnerOrInternal &&
        userHasConsented === false && // we don't want this to evaluate true when null
        !portalHasCriticalError;

    return shouldShowConsentLandingPage;
};
